import React from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import pegiLogo from "assets/images/logos/licensing/logo_pegi.png";
import links from "links";
import ILogoLink from "./ILogoLink";
import LogoLink from "./LogoLink";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: { maxWidth: 65, "& img": { width: "100%" } },
        rating: {
            flex: "unset",
        },
    })
);

export default function RatingLogo() {
    const classes = useStyles();

    const logoLink: ILogoLink = {
        logo: <img src={pegiLogo} alt="Pegi Logo" />,
        link: links.licensing.pegi,
        className: classes.rating,
    };

    return <LogoLink className={classes.root} logoLink={logoLink} />;
}
